// Store
import store from '@/app/stores/store.js';

export const authApiInterceptor = (instance) => {
	// Interceptors
	instance.interceptors.request.use(config => {
		// Add token to req headers
		const authJwtToken = store.getters.getAuthToken;
		if (authJwtToken) {
			config.headers['Authorization'] = `Bearer ${authJwtToken}`;
		}
		return config;
	}, function (error) {
		return Promise.reject(error);
	});

	instance.interceptors.response.use(response =>  {
		return response;
	}, function (error) {
		return Promise.reject(error);
	});
}